import { Box, ThemeProvider } from '@mui/material';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import React, { useEffect, useRef } from 'react';
import { generateTheme } from '../themes';

gsap.registerPlugin(ScrollTrigger);

const ImageFullwidth = ({ sliceData }) => {
    const imageRef = useRef();
    const scrollTriggerRef = useRef();

    useEffect(() => {
        const element = imageRef.current;

        scrollTriggerRef.current = ScrollTrigger.create({
            trigger: element,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            onUpdate: self => {
                const maxScroll = element.offsetWidth - window.innerWidth;
                const xValue = -maxScroll * self.progress;
                gsap.to(element, { x: xValue });
            }
        });

        return () => {
            if (scrollTriggerRef.current) {
                scrollTriggerRef.current.kill();
            }
        };
    }, []);

    let src = sliceData.primary.image.url;
    let alt = sliceData.primary.image.alt ? sliceData.primary.image.alt : src;
    let aspectRatio = sliceData.primary.image.dimensions.width / sliceData.primary.image.dimensions.height;

    const theme = generateTheme(sliceData?.primary?.color_theme);

    return (
        <ThemeProvider theme={theme}>
            <Box className="image-fullwidth" sx={{ lineHeight: 0,  background: (theme) => theme.palette.background.default }} >
                <img ref={imageRef} src={src} alt={alt} loading="lazy" style={{ width: 'auto', maxWidth: 'none', aspectRatio: aspectRatio }} />
            </Box>
        </ThemeProvider >
    );
};

export default ImageFullwidth;
